import { secondsToHoursWithMinutes } from "@src/utils/time";

export const TASK_REVISION_CHECK_INTERVAL = 10000;

export function timeToHrs(time: number, decimals = 1): string {
  const timeNum = typeof time === "number" ? time : Number(time ?? 0);
  return (timeNum / 3600).toFixed(decimals);
}

export function formatTrackedTime(seconds: number | null | undefined): string {
  return secondsToHoursWithMinutes(Math.max(0, Number(seconds ?? 0)));
}

export function shortUserName(user: {
  first_name?: string | null;
  last_name?: string | null;
  full_name?: string | null;
}): string {
  if (user.first_name && user.last_name) {
    return `${user.first_name[0]}. ${user.last_name}`;
  }

  return user.full_name ?? "";
}
